import ThemeContext from './ThemeContext';

export default ThemeContext;
